import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { observer } from 'mobx-react-lite'

import { ICustomerDetails } from 'pages/excursions/customer-details'

import { IExcursionsOrder } from 'entities/excursions/models/order-excursions/model'
import { orderExcursionsStore } from 'entities/excursions/models/order-excursions/order-excursions-store'
import { mplusStore } from 'entities/mplus/module/mplus-store'
import { MplusPopup } from 'entities/mplus/ui/mplus-popup'
import { mplus_deeplink } from 'entities/mplus/ui/take-in-mplus/constants'

import { OrderExcursions } from 'shared/api/excursions/order'
import ErrorImage from 'shared/images/error.png'
import { openDeepLink } from 'shared/lib/deep-link-open'
import { getErrorMessage } from 'shared/lib/errorText'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { MPlusConnect } from 'shared/ui/mplus-connect'
import { PopupContent } from 'shared/ui/poup-content'

const MPlus = observer(() => {
  const { closeDialog, openDialog } = useDialogBottomSheet()
  const [isLoader, setLoader] = useState(false)

  const { t } = useTranslation()

  const { people_quantity, total_price, excursion_id } =
    orderExcursionsStore.orderExcursionInfo

  const totalPrice = total_price
  const quantity = people_quantity

  const handleExcursionBooking = async (data: ICustomerDetails) => {
    setLoader(true)

    try {
      const dataPurchase: IExcursionsOrder = {
        people_quantity,
        total_price,
        client_first_name: data.first_name,
        client_last_name: data.last_name,
        client_email: data.email,
        client_phone: `${data.phone.code}${data.phone.phone}`,
        excursion_id,
      }

      await OrderExcursions.orderExcursion(dataPurchase)
    } catch (err) {
      const errorText = getErrorMessage(err)

      onShowError(errorText)
    } finally {
      setLoader(false)
    }
  }

  const handleExcursionPurchase = () => {
    const excursionData = mplusStore.getExcursionsData()

    if (excursionData) {
      handleExcursionBooking(excursionData)
      openDialog({
        child: (
          <MplusPopup
            title={t('mplus.your_excursion_saved')}
            description={t('mplus.redirect_excursion')}
            onClick={() => openDeepLink(mplus_deeplink)}
          />
        ),
        isDialog: false,
        isClickable: false,
      })
    } else {
      openDeepLink(mplus_deeplink)
    }
  }

  const onShowError = (errorMessage?: string) => {
    openDialog({
      child: (
        <PopupContent
          image={ErrorImage}
          title={t('error')}
          description={errorMessage || t('please_tey_again')}
          button={t('try_again')}
          onClick={closeDialog}
        />
      ),
      isDialog: false,
    })
  }

  return (
    <MPlusConnect
      loaderType="excursions"
      totalPrice={totalPrice}
      quantity={quantity}
      isLoader={isLoader}
      onSubmit={handleExcursionPurchase}
    />
  )
})

export default MPlus
